import { intrinsicClassName } from '../../../utils/reactView';
import styles from './Report.module.css';

export const ReportTitle = intrinsicClassName('div', styles.title);
export const ReportFooter = intrinsicClassName('div', styles.footer);
